<script>
  // A collapsible metadata card for the sidebar of a detail page. Optional
  // "view all" link (e.g. to the full related-entity list page).
  import Button from './ui/button.svelte'
  import Icon from './ui/icon.svelte'

  let { title, viewAllHref = null, viewAllLabel = 'View all', collapsible = true, children } = $props()
  let open = $state(true)
</script>

<div class="card bg-base-100 border border-base-300">
  <div class="flex items-center justify-between px-4 py-3">
    <button
      type="button"
      class="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-base-content/60"
      onclick={() => collapsible && (open = !open)}
      disabled={!collapsible}
    >
      {title}
      {#if collapsible}<Icon name={open ? 'chevron_down' : 'chevron_right'} size="xs" />{/if}
    </button>
    {#if viewAllHref}
      <Button variant="link" size="xs" href={viewAllHref} class="px-0">{viewAllLabel}</Button>
    {/if}
  </div>
  {#if open}
    <div class="px-4 pb-4 -mt-1">{@render children()}</div>
  {/if}
</div>
